export let ServiceConfig = {
  baseUrl: "https://dev.appvoorschool.info",
  categorySuffix: "/category",
  schoolUrl: "/api",
  canUrl: "/api/can",
  userUrl: "/api/user",
  group: {
    listUrl: "/api/group",
    detailUrl: "/api/group/{id}"
  },
  category: {
    listUrl: "/api/category",
    detailUrl: "/api/category/{id}"
  },
  tag: {
    listUrl: "/api/tag",
    detailUrl: "/api/tag/{id}"
  },
  document: {
    listUrl: "/api/document",
    detailUrl: "/api/document/{id}"
  },
  gallery: {
    listUrl: "/api/gallery",
    detailUrl: "/api/gallery/{id}"
  },
  survey: {
    listUrl: "/api/survey",
    detailUrl: "/api/survey/{id}",
    answer: "/api/survey/{id}/answer"
  },
  news: {
    listUrl: "/api/post",
    detailUrl: "/api/post/{id}"
  },
  activity: {
    listUrl: "/api/activity",
    detailUrl: "/api/activity/{id}",
    subscribe: "/api/activity/{id}/subscription"
  },
  newsletter: {
    listUrl: "/api/newsletter",
    detailUrl: "/api/newsletter/{id}"
  },
  notifications: {
    listUrl: "/api/notification",
    detailUrl: "/api/notification/{id}",
    countUrl: "/api/notification/count",
    readAllUrl: "/api/notification/read",
  },
  agenda: {
    listUrl: "/api/calendar",
    detailUrl: "/api/calendar/{id}"
  },
  report: {
    reportSick: "/api/report_sick"
  },
  appointment: {
    listUrl: "/api/appointment",
    detailUrl: "/api/appointment/{id}",
    codeListUrl: "/api/appointment/code?code={code}",
    schedule: "/api/appointment/schedule"
  },
  push: {
    subscribe: "/api/subscribe"
  },
  settings: {
    url: "/api/settings"
  },
  staticPage: {
    listUrl: "/api/static_page",
    detailUrl: "/api/static_page/{id}"
  },
  loginUrl: '/api/login',
  logoutUrl: '/api/logout',
  refreshUrl: '/api/refresh',
  passwordUrl: '/api/password',
  forgotUrl: '/api/forgot',
  headerBgColor: '#e71e6e',
  headerFgColor: '#ffffff',
};



// WEBPACK FOOTER //
// ./src/app/services-config.ts